import React from 'react';
import Image from 'react-bootstrap/Image'
import AppVars from '../../../../AppVars.js';
import ToyotaLogo from '../../../../static/images/ty-login-logo.png'

import { constants } from '../../../../constants/constants';

const appVars = AppVars.getInstance();

class ResetSuccessView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props
        }
    }
    render() {
        return (
            <div>
                <div role="banner">
                    <div>
                        <a href={appVars.getAppHomeURL(this.props.style)}><Image className="login-log-resend" src={require('../../../../static/images/Toyota-Logo.svg').default} alt="Toyota" /></a>
                    </div>
                    <h1 className="title__TO block" style={{ 'margin': '75px 20px 40px 20px', 'width': 'auto' }}>
                        {constants.PASSWORD_SUCCESS_TITLE}
                    </h1>
                </div>
                <div role="main" className="body-container__TO">
                    <div className="message__TO">Please click below to sign in.</div>
                    <button id="login" style={{ 'marginTop': '30px' }} className="button__TO" onClick={this.props.login}>Sign In</button>
                </div>
            </div>
        );
    }
}

export default ResetSuccessView;